// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"033b0f3c319a7721","818":"5bebf540f6673a1c","915":"cec625044bc0c9e4"}[chunkId] + ".js";
};